import {
  IChangeCurrentUser,
  IChangePassword,
  IChangeStatus,
  ISaveUser,
  IUpdateUser,
  IUser,
} from "models/church.types";
import api from "./api"; // instance axios
import { environnement } from "configs/environnement";

const UserService = {
  // Liste paginée (ex: page=0&size=10)
  getAll: (page: number, size: number, query?: string) => {
    return api.get<IUser[]>(`${environnement.baseURL}/users/list`, {
      params: { page, size, query },
    });
  },

  // Détail d'un utilisateur
  getById: (id: number) => {
    return api.get<IUser>(`${environnement.baseURL}/users/detail/${id}`);
  },

  // Infos de l'utilisateur connecté (pour le menu/profil)
  getCurrentAccount: () => {
    return api.get<IUser>(`${environnement.baseURL}/users/current-user`);
  },

  // Création
  create: (user: ISaveUser) => {
    return api.post<IUser>(`${environnement.baseURL}/users`, user);
  },

  // Mise à jour (UpdateUserDTO côté Java)
  update: (user: IUpdateUser) => {
    return api.put<IUser>(`${environnement.baseURL}/users`, user);
  },

  // Suppression (Désactivation logique dans ton cas)
  delete: (id: number) => {
    return api.delete(`${environnement.baseURL}/users/${id}`);
  },

  // Activation / Désactivation (ChangeStatusDTO)
  changeStatus: (status: IChangeStatus) => {
    return api.put(`${environnement.baseURL}/users/change-status`, status);
  },

  // Changement de mot de passe
  changePassword: (data: IChangePassword) => {
    return api.put(`${environnement.baseURL}/users/change-password`, data);
  },

  // Changement de l'utilisateur connecté
  changeCurrentUser: (data: IChangeCurrentUser) => {
    return api.put(`${environnement.baseURL}/users/change-current-user`, data);
  },
};

export default UserService;
